import * as TYPES from '../types';

export const getAllVacanciesAction = () => {
    return {
        type: TYPES.GET_ALL_VACANCIES,
    };
};

export const getAllVacanciesSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_VACANCIES_SUCCESS,
        payload: payload
    };
};
